import { useEffect, useState } from 'react';
import { createClient } from '../../utils/supabase/client';

type ConnectionState = 'checking' | 'connected' | 'error';

export function SupabaseConnected() {
  const [connectionState, setConnectionState] = useState<ConnectionState>('checking');
  const [message, setMessage] = useState('Checking Supabase connection...');

  useEffect(() => {
    const supabase = createClient();

    supabase
      .from('leads')
      .select('id', { count: 'exact', head: true })
      .then(({ error }) => {
        if (error) {
          setConnectionState('error');
          setMessage(error.message);
          return;
        }

        setConnectionState('connected');
        setMessage('Supabase Connected');
      });
  }, []);

  return (
    <section className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
      <div className="border border-slate-200 bg-white p-6 shadow-soft">
        <p className="section-eyebrow">Connection Test</p>
        <h1 className="mt-3 text-4xl font-bold">
          {connectionState === 'connected' ? 'Supabase Connected' : 'Supabase Connection'}
        </h1>
        <p
          className={`mt-5 border-l-4 px-4 py-3 text-sm font-semibold ${
            connectionState === 'connected'
              ? 'border-forest bg-green-50 text-forest'
              : connectionState === 'error'
                ? 'border-red-500 bg-red-50 text-red-700'
                : 'border-cyan bg-cyan/10 text-slate-700'
          }`}
          role={connectionState === 'error' ? 'alert' : 'status'}
        >
          {message}
          {connectionState === 'connected' ? ' OK' : ''}
        </p>
      </div>
    </section>
  );
}
